import { render } from "./EmpDashboardNewPage.vue?vue&type=template&id=5d448515"
import script from "./EmpDashboardNewPage.vue?vue&type=script&lang=js"
export * from "./EmpDashboardNewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__